var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyNotesEidit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8941 23.1568V21.0083L19.4305 14.4718L21.5791 16.6204L15.0426 23.1568H12.8941ZM2 16.8019V14.9862H11.0784V16.8019H2ZM22.8803 15.3191L20.7318 13.1706L21.6094 12.293C21.7708 12.1316 21.9826 12.0509 22.2448 12.0509C22.5071 12.0509 22.7189 12.1316 22.8803 12.293L23.7579 13.1706C23.9193 13.332 24 13.5438 24 13.8061C24 14.0683 23.9193 14.2801 23.7579 14.4415L22.8803 15.3191ZM2 11.8088V9.99312H16.2228V11.8088H2ZM2 6.81568V5H16.2228V6.81568H2Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNotesEidit);
export default __webpack_public_path__ + "static/media/myNotesEidit.9b58aa5a2d05dda5ebc70b37e9ab106b.svg";
export { ForwardRef as ReactComponent };